import axios from "axios";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "http://localhost:8000").replace(/\/$/, "");
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "azhd_access_token";

export function setAuthToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  } else {
    localStorage.removeItem(TOKEN_KEY);
  }
}

export function getAuthToken() {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
}

export const api = axios.create({
  baseURL: API_BASE,
  // Bearer token (in Authorization header) is our primary auth mechanism.
  // Cookies (withCredentials: true) conflict with `Access-Control-Allow-Origin: *`
  // and are blocked by browsers, causing a "Network Error" on the client.
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  }
  if (typeof detail === "object" && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
